export default __webpack_public_path__ + "static/media/front-mob.44602846.png";